<template>
  <div id="loan-summary">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/projects')" style="cursor: pointer">Proyectos</li>
        <li class="breadcrumb-item active" aria-current="page">{{ project.id }} {{ project.alias }}</li>
      </ol>
    </nav>

    <div class="m-4">
      <div class="vx-row mb-4">
        <div class="vx-col w-full lg:w-full">
          <vx-card class="mt-2" card-background="dark">
            <h1 class="bold big-title m-0 text-white">
              Expediente de <span class="success">originación</span>.</h1>
          </vx-card>
        </div>
      </div>
    </div>
    <template v-if="moduleIsLoaded">
      <div class="container-fluid">

        <!-- SUPPLIER RESTRICTION NOTIF -->
        <div v-if="project.supplier_id != null" class="vx-row">
          <div class="vx-col w-full">
              <SupplierRestrictedData :source="project.supplier" />
          </div>
        </div>

        <div class="vx-row mb-4">
          <!-- SOLICITANTE -->
          <div class="vx-col sm:w-full md:w-1/2 lg:w-1/3">
            <!-- Solicitante de proyecto -->
            <div id="applicant-detail" class="mb-4 vx-card p-2">
              <vs-tabs>
                <vs-tab label="Solicitante">
                  <ProfileDetail :source="project" :incomeSourcesData="incomeSources" />
                  <!-- cuentas de banco -->
                  <vs-divider></vs-divider>
                  <div id="cashing-data" class="mb-4 p-2">
                    <BankAccountsDetail :source="project" />
                  </div>
                </vs-tab>
                <vs-tab v-if="guaranteeRequired" :label="`Obligados solidarios: ${guarantees.length}`">
                  <!-- <ProfileDetail :source="source" :incomeSourcesData="incomeSources" :guaranteeRequired="guaranteeRequired"/> -->
                  <vs-tabs>
                    <vs-tab size="small" :key="index" v-for="(guarantee, index) in guarantees"
                      :label="`${getGuaranteeName(guarantee)}`">
                      <!-- {{ guarantee }} -->
                      <ProfileDetail :source="project" :incomeSourcesData="incomeSources" :guarantee="guarantee"
                        :guaranteeRequired="guaranteeRequired" />
                    </vs-tab>
                  </vs-tabs>
                </vs-tab>
              </vs-tabs>
            </div>
            <!-- cobranza -->
            <div id="cashing-data" class="mb-4 vx-card p-2">
              <CashingDetail :source="project" />
            </div>
          </div>
          <!-- PROYECTO -->
          <div class="vx-col sm:w-full md:w-1/2 lg:w-1/3">
            <project-header :isNewPage="false" :project="project" 
              :relatedProjects="relatedProjects" 
              @on-show-amort-tab="onShowAmortTab"
              @on-reload-project="onReloadProject"
              @on-preapprove-request="onPreapproveRequest"
              @on-approve-request="onApproveRequest"></project-header>
            <credit-events-log class="mt-4" :projectId="project.id" />
          </div>
          <!-- EVENTOS -->
          <div class="vx-col sm:w-full md:w-1/2 lg:w-1/3">
            <project-life-cycle :project="project"></project-life-cycle>
            <project-message-logger class="mt-4 mb-5"></project-message-logger>
            <loan-supplier-detail :source="project"></loan-supplier-detail>
            <!-- RESPONSABLE DEL CRÉDITO -->
            <div id="credit-responsible-card" class="mb-4 vx-card p-2">
              <h6 class="success bold">RESPONSABLE</h6>
              <AssignLoanResponsibles :type="'project_operator'" :loan="project"></AssignLoanResponsibles>
            </div>
            <!-- INFORMACIÓN DE FINANCIAMIENTO  -->
            <div id="finance-detail-card"  class="mb-4 vx-card p-2">
                <finance-detail :source="project"></finance-detail>
            </div>
          </div>
        </div>
        <!-- HERRAMIENTAS -->
        <div class="row">
          <div class="col-md-12 mt-4">
            <project-detail-v2 :id="project.id" ref="project_main"></project-detail-v2>
          </div>
        </div>
      </div>
    </template>

  </div>
</template>

<script>
import { formatPrice } from '@components/admin/filters';
import { mapState, mapActions, mapMutations } from 'vuex';
import ProjectLifeCycle from "../../../components/project-details/ProjectLifeCycle";
import ProjectHeader from "../../../components/project-details/ProjectHeader";
import ProjectMessageLogger from "../../../components/ProjectMessageLogger";
import ProjectDetailV2 from "../projectsv2/ProjectDetail";
import CreditEventsLog from "@components/projectsv2/CreditEventsLog";
import ProfileDetail from '../RiskModel/LoanRequest/components/ProfileDetail.vue';
import BankAccountsDetail from '../RiskModel/LoanRequest/components/BankAccountsDetail.vue';
import LoanSupplierDetail from '../RiskModel/LoanRequest/components/LoanSupplierDetail.vue';
import CashingDetail from '../RiskModel/LoanRequest/components/CashingDetail.vue';
import FinanceDetail from '../RiskModel/LoanRequest/components/FinanceDetail.vue';
import AssignLoanResponsibles from '../../../components/projectsv2/components/AssignLoanResponsibles.vue';

const STATUS = ["sin verificar"];
export default {
  data: () => ({
    moduleIsLoaded: false,
    relatedProjects: {},
    incomeSources: [],
  }),
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('projects', ['project']),
    ...mapState(['loading']),
    finance() {
      return this.project.finance;
    },
    guaranteeRequired() {
      return this.moduleIsLoaded ? this.finance.guarantee_required == 1 : false;
    },
    guarantees() {
      return this.moduleIsLoaded ? this.finance.guarantees : [];
    },
  },
  watch: {
    $route(to, from) {
      this.initComponent();
    }
  },
  async mounted() {
    this.hideMenu();
    await this.initComponent();
  },
  components: {
    ProjectMessageLogger,
    ProjectHeader,
    ProjectLifeCycle,
    ProjectDetailV2,
    CreditEventsLog,
    ProfileDetail,
    BankAccountsDetail,
    LoanSupplierDetail,
    CashingDetail,
    FinanceDetail,
    AssignLoanResponsibles
  },
  methods: {
    ...mapMutations('menu', ['hideMenu']),
    ...mapActions('projects', ['getProject']),
    ...mapMutations('projects', ['setProject']),
    formatPrice,
    onShowAmortTab() {
      this.$refs.project_main.showAmortTable();
    },
    async initComponent() {
      try {
        this.moduleIsLoaded = false;
        const id = this.$route.params.id;
        let project = await this.getProject({
          id: id,
          rel: [
            "splits",
            "agent",
            "agent.phone",
            "agent.user",
            "finance",
            "contracts",
            "supplier.user",
            "supplier.user.personal",
            "supplier.user.business",
            "supplier.user.business.personal",

            'client.user.personal.address',
            'client.user.personal.creditProfile',
            'client.user.personal',
            'client.user.personal.occupation',
            'client.user.personal.bankAccounts',
            'client.user.personal.phone',
            'client.user.personal.identityVerifications',

            'client.kycProfile',

            'client.user.business.address',
            'client.user.business.personal.address',
            'client.user.business.personal.creditProfile',
            'client.user.business.personal',
            'client.user.business.personal.occupation',
            'client.user.business.personal.identityVerifications',
            'client.user.business.personal.phone',
            'client.user.business.country',
            'client.user.business.businessActivity',
            'client.user.business',
            'client.user.business.creditProfile',
            'client.user.business.bankAccounts',
            'client.user.business.phone',

            'finance.guarantees.personal',
            'finance.guarantees.personal.phone',
            'finance.guarantees.personal.address',
            'finance.guarantees.personal.creditProfile',
            'finance.guarantees.personal.occupation',
            'finance.guarantees.personal.identityVerifications',
            'finance.guarantees.business.address',
            'finance.guarantees.business.phone',
            'finance.guarantees.business.creditProfile',
            'finance.guarantees.business.personal.phone',
            'finance.guarantees.business.personal.address',
            'finance.guarantees.business.personal.occupation',
            'finance.guarantees.business.personal.identityVerifications',
            'finance.guarantee.guaranteeProfile.personal.phone',
            'finance.guarantee.guaranteeProfile.personal.occupation',
            'finance.guarantee.guaranteeProfile.business.phone',
            'finance.guarantee.guaranteeProfile.personal.creditProfile',
            'finance.guarantee.guaranteeProfile.personal.address',
            'finance.guarantee.guaranteeProfile.business.creditProfile',
            'finance.guarantee.guaranteeProfile.business.address',
            'finance.guarantee.guaranteeProfile.business.personal.phone',
            'finance.guarantee.guaranteeProfile.business.personal.occupation',
            'finance.guarantee.guaranteeProfile.business.personal.identityVerifications',
            'pgmPotentialApplicant'
          ]
        });

        window.document.title = `PID: ${id} - Originación`;

        // solicitar proyectos relacionados
        const res = await axios.get(`/api/v2/projects/${id}/getProjectsRelated`);
        this.relatedProjects = res.data;

        this.setProject(project);
      } catch (e) {

      } finally {
        this.moduleIsLoaded = true;
      }
    },
    goToDetails(id) {
      window.location.href = "/project/" + id;
    },
    async onPreapproveRequest() {
      let main = this.$refs.project_main;
      await main.preapproveRequest();

    },
    async onApproveRequest() {
      let main = this.$refs.project_main;
      await main.approveRequest();
    },
    async onReloadProject() {
      let project = await this.getProject({
        id: this.$route.params.id,
        rel: [
          'client',
          'supplier',
          'splits',
          'finance',
          'contracts',
        ]
      });
      this.setProject(project);
    },
    getGuaranteeName(guarantee) {
      try {
        if (guarantee.personal_profile_id != null) {
          const personal = guarantee.personal;
          return `${personal.first_name} ${personal.last_name_1}`;
        } else {
          const business = guarantee.business;
          return business.name;
        }
      } catch (error) {
        console.log(error);
        return "NA";
      }
    },
  }
}
</script>

<style>
.process-proyect {
  margin-bottom: 40px !important;
}

.done {
  background: #7CB342;
  color: white;
}

.close-date {
  background: #FFF59D;
  color: white;
}

.collar-box {
  text-align: center;
  position: relative;
  width: 7.6%;
}

.collar-box i.material-icons {
  font-size: 10px;
}

.timeline-label {
  background: #1976d2;
  color: #FFF;
  margin-top: 3px;
}

.collar-box-button {
  height: 60px;
}

.separator {
  position: absolute;
  top: 18px;
  right: -8px;
}

.activity-name {
  font-size: 10px;
}

.activity-name-text {
  height: 26px;
}

.activity-name-text.strong {
  font-weight: bold;
}
</style>
